import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import nlTranslations from './locales/nl.json';
import deTranslations from './locales/de.json';
import frTranslations from './locales/fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      nl: {
        translation: nlTranslations,
      },
      de: {
        translation: deTranslations,
      },
      fr: {
        translation: frTranslations,
      },
    },
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Check localStorage first to persist user's choice, then browser locale
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      // Normalize language codes (e.g., nl-NL -> nl, en-GB -> en)
      convertDetectedLanguage: (lng: string) => {
        // Extract base language code (e.g., 'nl' from 'nl-NL')
        const baseLanguage = lng.split('-')[0].toLowerCase();
        // Only return supported languages, otherwise fallback will be used
        return ['en', 'nl', 'de', 'fr'].includes(baseLanguage) ? baseLanguage : 'en';
      },
    },
  });

export default i18n;

